<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col">
    <div class="mb-3 flex items-start gap-4">
      <div class="flex flex-col gap-1 text-sm">
        <span class="text-gray-700">
          The AI applies the AI rules in effect for this program to each configuration of this program. AI findings
          are questions for you to decide, not errors. Accept a finding when it is intended, or Dismiss it when the AI
          is wrong; a Block finding needs a reason. A Warn finding never stops activation. To fix one, change the
          configuration and run the check again.
        </span>
        <span class="font-semibold">{{ runText() }}
          @if (review) {
            {{ openCount() === 0 ? 'No open blocking findings.' : openCount() + ' open blocking finding(s).' }}
            {{ warningCount() === 0 ? '' : warningCount() + ' open warning(s).' }}
          }
        </span>
      </div>
      @if (!isReadOnly() && !parent.isBeingAdded) {
        <div class="ml-auto shrink-0">
          <prox-ai-button label="Run AI Program Check" [loading]="isRunning"
            tooltip="The AI checks each configuration of this program. About a minute for every four configurations."
            (clicked)="onRunCheck()"></prox-ai-button>
        </div>
      }
    </div>

    @if (staleText && !isRunning) {
      <div class="mb-2 rounded border border-red-300 bg-red-50 p-3 text-sm font-semibold text-red-700">{{ staleText }}</div>
    }

    @if (runError) {
      <div class="mb-2 rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">
        <div class="font-semibold">The AI Program Check did not run</div>
        <div>{{ runError }}</div>
      </div>
    }

    @if (isRunning) {
      <div class="flex grow flex-col items-center justify-center gap-4">
        <p-progressSpinner styleClass="h-16 w-16" strokeWidth="4" animationDuration="1s" ariaLabel="The AI is checking the program" />
        <div class="text-base font-semibold">The AI is checking {{ program.name }}</div>
        <div class="text-sm text-gray-600">About a minute for every four configurations. {{ runElapsed }} seconds so far.</div>
      </div>
    }
    <!-- The grid stays in the page while the check runs, so it keeps its columns. -->
    <div [class]="isRunning ? 'hidden' : 'grow'">
      <prox-ag-grid [gridOptions]="gridOptions" [rowData]="findings"></prox-ag-grid>
    </div>
  </div>
</div>
